import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { ColumnDirective, ColumnsDirective, GridComponent } from '@syncfusion/ej2-react-grids';
import { ExcelExport, Edit, Inject, Toolbar } from '@syncfusion/ej2-react-grids';
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NHaF5cWWFCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWH9ceXRQR2BeUkdyXUM=');
import {
    FormGroup,
    Label,

} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    allStudents
} from 'Actions';


class TestTable extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();

    }
    constructor(props) {

        super(props);
        this.state = {
            student: '',
            reportdate: this.props.data.reportdate,

        };

    }



    render() {

        const { studentsavailable, loading } = this.props;

        let studentlist = [];
        if (studentsavailable.length !== 0) {
            studentlist = studentsavailable.availablestudent;
        }

        const tabledata = [];
        let visitingStudentsAdded = false;

        studentlist.forEach((assmntval, idx) => {
            if (assmntval.frmwhr === 2 && !visitingStudentsAdded) {
                tabledata.push({
                    name: 'Visiting Students',
                    isHeader: true,
                });
                visitingStudentsAdded = true;
            }

            tabledata.push({
                no: idx + 1,
                name: assmntval.student,
                checkouttime: assmntval.checkouttime,
                checkintime: assmntval.checkintime,
            });
        });
        let grid;
        const selectionOptions = { type: 'Multiple' };
        const toolbar = ['Delete', 'ExcelExport', 'Search'];
        const toolbarClick = (args) => {
            if (grid) {
                if (args.item.id === 'grid_excelexport') {
                    //const selectedRecords = grid.getSelectedRecords();
                    const exportProperties = {
                        // dataSource: selectedRecords,
                        header: {
                            headerRows: 2,
                            rows: [
                                { cells: [{ colSpan: 4, value: "Student Availability Report - " + this.state.reportdate + "", style: { fontColor: '#C67878', fontSize: 20, hAlign: 'Center', bold: true, } }] }
                            ]
                        },
                        fileName: "Student Availability Report - " + this.state.reportdate + ".xlsx"
                    };
                    grid.excelExport(exportProperties);
                }
            }
        };
        const searchOptions = {
            fields: ['CustomerID'],
            ignoreCase: true,
            operator: 'contains'
        };
        const editOptions = { allowDeleting: true };

        return (
            <div>
                <div className="col-sm-12 col-lg-8" style={{ margin: "0 auto" }}>
                    <RctCollapsibleCard heading="Students List" fullBlock>
                        <GridComponent id='grid' dataSource={tabledata} allowFiltering={true} allowExcelExport={true} toolbar={toolbar} searchSettings={searchOptions} editSettings={editOptions} selectionSettings={selectionOptions} toolbarClick={toolbarClick} ref={g => grid = g}>
                            <ColumnsDirective>
                                <ColumnDirective type='checkbox' width='50' check='true' />
                                <ColumnDirective field='no' headerText='NO' width='50' />
                                <ColumnDirective
                                    field='name'
                                    headerText='NAME'
                                    width='150'
                                    template={(props) => {
                                        if (props.isHeader) {
                                            return (
                                                <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                                    {props.name}
                                                </div>
                                            );
                                        } else {
                                            return props.name;
                                        }
                                    }}
                                />
                                <ColumnDirective field='checkouttime' headerText='CHECK-OUT-TIME' width='150' />
                                <ColumnDirective field='checkintime' headerText='CHECK-IN-TIME' width='150' />
                            </ColumnsDirective>
                            <Inject services={[Edit, Toolbar, ExcelExport]} />
                        </GridComponent>
                    </RctCollapsibleCard>
                </div>
            </div>

        )

    }

}

const mapStateToProps = ({ visitors }) => {
    const { studentsavailable, loading } = visitors;
    return { studentsavailable, loading };

}


export default connect(mapStateToProps, {
    allStudents
})(TestTable);
